import { Component, Input, AfterContentInit, ElementRef } from '@angular/core';
import { DivisionDTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { UIService } from '../../ui.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { AppConfiguration } from '../../conf/app.configuration';

@Component({
  selector: 'divisionDetail',
  templateUrl: 'divisionDetail.template.html'
})
export class DivisionDetailComponent extends BaseComponent implements AfterContentInit {

  cliente: any;

  @Input() division: DivisionDTO;
  @Input() project: any;
  @Input() infoLink = true;
  @Input() infoTitulo = true;
  @Input() showDivisionInfo = false;
  @Input() parentElement: any;
  @Input() dossierType: string;
  loaded = false;


  constructor(public uiService: UIService,
    private translateService: TranslateService,
    protected router: Router,
    private plycaService: PlycaDataService,
    private configuration: Configuration,
    private appConfig: AppConfiguration,
    private elemRef: ElementRef) {
    super();
    this.cliente = this.appConfig.getValue('cliente');
  }

  ngAfterContentInit(): void {

    if (this.parentElement == null)
      this.parentElement = this.elemRef;

    if (this.project == null && this.division != null) {
      this.project = this.division.project;
    }
    this.loaded = true;

    /*   else if (this.project != null && this.division == null) {
         let url = this.configuration.DIVISION_SERVICE_URL;
         url = url.replace('{dossierId}', this.project.identifier);
         this.plycaService.get(url, '0', this.getQueryParams())
           .subscribe((param: DivisionDTO) => {
             this.project = param.project;
             this.loaded = true;
           });
       }
   */
  }
  private getQueryParams() {
    return {
      expand: 'expansionSet:detail'
    };
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  getContractFolderId() {
    if (this.dossierType && this.dossierType === 'CONTRACTS') {
      return this.project.contractFolderId + ' / ' + getSimpleIdentifierFromString(this.division.identifier);
    } else {
      return this.project.contractFolderId;
    }
  }

  openDossier() {
    if (this.dossierType && this.dossierType === 'CONTRACTS') {
      if ('AYMAD' === this.cliente) {
        this.router.navigate(['/dossierInfo/' + this.project.identifier], { queryParams: { component: 'CONTRACTSAYMAD', divisionId: getSimpleIdentifierFromString(this.division.identifier) } });
      } else {
        this.router.navigate(['/dossierInfo/' + this.project.identifier], { queryParams: { component: 'CONTRACTS', divisionId: getSimpleIdentifierFromString(this.division.identifier) } });
      }
    } else {
      this.router.navigate(['/dossierInfo/' + this.project.identifier]);
    }
  }
  /*
   Normal(0),
         // Recurso
         Appealed(1),
         Discrepancy(2),
         Cancelled(3),
         Extinguished(4),
         Support(5);*/
  getIconClass() {
    let iconClass = 'fa-archive';

    try {
      if (this.project.documentClass.identifier == '00600') {
        return 'fa-file-contract'
      }
    } catch { }

    return iconClass;
  }
  getSituationClass() {
    let styleClass = this.getIconClass() + ' '; // default class
    if (this.project.status) {
      let situation = this.project.status.situation;
      if (!this.project.status) {
        status = this.division.project.status.situation;
      }

      if (situation) {
        switch (situation) {
          case 'Normal': { // normal
            styleClass += 'text-emphasis';
            break;
          }
          case 'Extinguished': { // Extingido
            styleClass += 'text-success';
            break;
          }
          case 'Cancelled': { // Cancelado
            styleClass += 'text-danger';
            break;
          }
          case 'Support': { // Modo soporte
            styleClass += 'text-secondary';
            break;
          }
          case 'Appealed': { // Modo recurso
            styleClass += 'text-warning';
            break;
          }
          case 'Discrepancy': { // Modo discrepancia
            styleClass += 'text-warning';
            break;
          }
          default: {
            styleClass += 'text-emphasis';
            break;
          }
        }
      }
      // Fase cerrado de expedientes de encargo
      if (this.project.phase && this.project.phase.identifier && this.project.phase.identifier === '402<>EXPFASE') {
        styleClass = this.getIconClass() + ' ' + 'text-success';
      }
    }
    return styleClass;
  }


  getSituationText() {
    let styleClass = this.translateService.instant('DossierDetail.situation.normal');; // default text
    switch (this.project.status.situation) {
      case 'Normal': { // normal
        styleClass = this.translateService.instant('DossierDetail.situation.normal');
        break;
      }
      case 'Extinguished': { // Extingido
        styleClass = this.translateService.instant('DossierDetail.situation.terminated');
        break;
      }
      case 'Cancelled': { // Cancelado
        styleClass = this.translateService.instant('DossierDetail.situation.canceled');
        break;
      }
      case 'Support': { // Modo soporte
        styleClass = this.translateService.instant('DossierDetail.situation.supportmode');
        break;
      }
      case 'Appealed': { // Modo recurso
        styleClass = this.translateService.instant('DossierDetail.situation.Appealed');
        break;
      }
      case 'Discrepancy': { // Modo discrepancia
        styleClass = this.translateService.instant('DossierDetail.situation.Discrepancy');
        break;
      }
    }
    return styleClass;
  }
  truncateDivisionDescription(name: string) {
    if (!name)
      return '';
    if (name.length > 200)
      return name.substring(0, 200) + " ...";
    else
      return name;
  }
}
